import AppRoot from "./AppRoot.tsx";

export default AppRoot;
